export default function buildCompanyName(name: string): string {
    const company1 = name.replace('Advance', 'Adv.')
    const company2 = company1.replace('Laboratorios', 'Lab.')
    const company3 = company2.replace('Sociedad', 'S.')
    return company3.replace('Anónima', 'A.')
}
